export const manageMasterDataLogoActive = '/manage_active.png';
export const crossPdf = './crossPdf.png';
export const tickIcon = './tickIcon.png';
export const bookingConfirm = './booking-confirmed.png';
export const lifeLine = '/lifeline.png';
export const starIconRating = '/star-icon.png';
export const profile_preview = '/profile_preview.png';
export const favorite = '/favorite.png';
export const userProfile = './userProfile.png';
export const support = '/support.png';
export const mySchedule = '/myAppointment.png';
export const hospitalUpload = '/hospitalUpload.png';
export const doctorSearchActive = '/doctorSearchActive.png';
export const doctorSearch = '/doctorSearch.png';
export const translate = './translate.png';
export const upCommingAppointmentActive = '/upCommingAppointmentActive.png';
export const upCommingAppointment = '/upCommingAppointment.png';
export const myScheduleActive = '/myAppointmentActive.png';
export const patientQueueActive = '/patientQueueActive.png';
export const patientQueue = '/patientQueue.png';
export const payment = '/profits.png';
export const paymentActive = '/profits_active.png';
export const imports = '/import.png';
export const importsActive = '/importActive.png';
export const followUpActive = '/followUpActive.png';
export const followUp = '/followUp.png';
export const supportActive = '/support_active.png';
export const managePatientsLogoActive = '/patient_active.png';
export const manageClinicsLogoActive = '/clinic_active.png';
export const analyticsLogoActive = '/analytics_active.png';
export const manageMasterDataLogo = '/manage.png';
export const managePatientsLogo = '/patient.png';
export const manageClinicsLogo = '/clinic.png';
export const analyticsLogo = '/analytics.png';
export const headerLogo = '/header_logo.png';
export const notInterested = 'not_interested-24px@3x.png';
export const screenExpandIcon = '/ic_expand.png';
export const profile = '/profile.png';
export const withoutProfile = '/without-profile-pic.png';
export const flagIcon = '/logo.png';
export const flagGreyIcon = './flagGrey.png';
export const searchIcon = '/search.png';
export const newSearchIcon = '/NewSerach.png';
export const notificationIcon = '/ic_notification.png';
export const userIcon = '/user.png';
export const busIcon = '/bus.png';
export const complainIcon = '/complaint.png';
export const dashBoardIcon = '/dashboard.png';
export const schoolIcon = '/school.png';
export const teamIcon = '/team.png';
export const rupeeIcon = '/finance.png';
export const rupeeIcon1 = '/rupee1.png';
export const routeIcon = '/route.png';
export const colorRouteIcon = '/routeIcon.png';
export const familyIcon = '/shape.png';
export const checkBoxIcon = '/checkbox.png';
export const checkSelectedIcon = '/checkbox-selected.png';
export const unCheckboxIcon = '/unCheckbox.png';
export const backIconNew = '/back.png';
export const homeIcon = '/home.png';
export const parentChild = '/parentChild.jpg';
export const starIcon = '/star.png';
export const arrowDownIcon = '/arrowDown.png';
export const yellowStarIcon = '/yellowStar.png';
export const collapseIcon = './collapse.png';
export const expandIcon = './expand.png';
export const reportsIcon = './reports.svg';
export const sortUpIcon = '/sortUp.png';
export const moreOptionsIcon = '/moreOptions.png';
export const profileIcon = '/userIcon.png';
export const mobileIcon = '/mobileIcon.png';
export const uploadIcon = './ic_upload.png';
export const documentIcon = './documents.png';
export const crossIcon = './crossIcon.png';
export const calenderIcon = './ic_calender.png';
export const backCrossIcon = './backCrossIcon.png';
export const downArrow = './downArrow.png';
export const sortDownIcon = './sortDown.png';
export const descendingSortIcon = './arrowDownSort.png';
export const ascendingSortIcon = './arrowUpSort.png';
export const plusIcon = './plus.png';
export const zoomInIcon = './zoomIn-icon.png';
export const zoomInSelectedIcon = './zoomIn-selected-icon.png';
export const zoomOutIcon = './zoom-out-icon.png';
export const zoomOutSelectedIcon = './zoom-out-selected-icon.png';
export const resetZoomIcon = './resetZoom.png';
export const resetZoomSelectedIcon = './resetSelectedZoom.png';
export const nextIcon = './next.png';
export const previousIcon = './previous.png';
export const mayaMdLogo = './mayaMdLogo.png';
export const pathIcon = './path.png';
export const path_greyIcon = './path_grey.png';
export const relocateNewIcon = './arrowUp.png';
export const tripIcon = './trip.png';
export const listViewIcon = './listView.png';
export const leftRightArrowsIcon = './leftRightArrows.png';
export const cameraIcon = './camera.png';
export const blackStarIcon = './blackStar.png';
export const sendChatIcon = './sendMessage.png';
export const chatBotFlagIcon = './chatbotFlag.png';
export const liveCameraIcon = './liveCamera.png';
export const deviceIcon = './device.png';
export const mapDirectionIcon = './mapDirection.png';
export const dublicateIcon = './dublicate.png';
export const newDeleteIcon = './deleteIcon.png';
export const greenLoacIcon = './Password.png';

export const complaintBusIcon = './ic_bus.png';
export const complaintReportIcon = './ic_report.png';
export const complaintFeeIcon = './ic_wallet.png';
export const chatIcon = './chat.png';

export const arrivalExpectedIcon = './arrivalExpected.png';
export const schoolLeftIcon = './schoolLeft.png';
export const schoolReachedIcon = './schoolReached.png';
export const stopReachedIcon = './stopReached.png';
export const vehicleStartedIcon = './vehicleStarted.png';
export const vehicleFlippedIcon = './vehicleFlipped.png';
export const playButtonIcon = './historyPlay.png';
export const historyStopIcon = './historyStop.png';
export const mapActionIcon = './mapActions.png';
export const studentIcon = './student.png';
export const montageNextWhiteIcon = './triangle.png';
export const montagePrevWhiteIcon = './trianglePre.png';
export const montagePlayIcon = './montagePlay.png';
export const youTubeLogo = 'youTubeLogo.png';
export const microphone = './microphone.png';
export const noMicrophone = './noMicrophone.png';
export const screenSharing = './screenSharingIcon.png';
export const pin = './pin.png';
export const unpin = './unpin.png';
export const stopVideo = './stopVideo.png';
export const stopVideoActive = './stopVideoActive.png';
export const videoColored = './videoColored.png';
export const videoWhite = './videoWhite.png';
export const imagePreview = './imagePreview.png';
export const videoPreview = './videoPreview.png';
export const pdfPreviewIcon = './pdfPreview.png';
export const descIcon = './desc.png';
export const bulletIcon = './bullets.png';
export const uploadPreview = './uploadReview.png';
export const uploadVideoPreview = './uploadVideoPreview.png';
export const backIcon = './backIcon.png';
export const uploadImageTransparent = './uploadImageTransparent.png';
export const greenStarIcon = './greenStar.png';
export const unSelectedStar = './unSelectedStar.png';
export const rightArrow = './rightArrow.png';
export const rightArrowWhite = './rightArrowWhite.png';
export const leftArrowWhite = './leftArrowWhite.png';
export const blackLeftArrow = './blackLeftArrow.png';
export const right_arrow = './right_arrow.png';
export const left_arrow = './left_arrow.png';
export const right_Arrow = './right_Arrow.png';
export const leftArrow = './leftArrow.png';
export const back_Icon = './backIcon.png';
export const wrongIcon = './wrongIcon.png';
export const subworkflow = './Subworkflow.png';

export const circleUnSelected = './circleUnSelected.png';
export const selectedCircle = './selectedCircle.png';
export const iconUserImage = './iconUserImage.png';
export const handRaised = './handRaised.png';
export const handRaisedActive = './handRaisedActive.png';
export const downloadIcon = './download.png';
export const sessionViewIcon = './sessionView.png';
export const microphoneMD = './newDarkThemeIcon/microphoneMD.png';
export const noMicrophoneMD = './newDarkThemeIcon/noMicrophoneMD.png';
export const handRaisedMD = './newDarkThemeIcon/handRaisedMD.png';
export const handRaisedActiveMD = './newImages/handRaisedActiveMD.png';
export const stopVideoMD = './newDarkThemeIcon/stopVideoMD.png';
export const stopVideoActiveMD = './newDarkThemeIcon/stopVideoActiveMD.png';
export const activeStudent = './activeStudent.png';
export const inActiveStudent = './inActiveStudent.png';
export const allTabSelectedIcon = './allTabSelected.png';
export const allTabUnSelectedIcon = './newDarkThemeIcon/tabAllInActive.png';
export const chatSelected = './chatselected.png';
export const rowMenuIcon = './ic_menu.png';
export const liveClassRoomIcon = './liveClassRoomIcon.png';
export const liveClassRoomSelected = './liveClassRoomSelected.png';
export const lessonPlan = './lessonPlan.png';
export const lessonPlanSelected = './lessonPlanSelected.png';
export const checkedIcon = './checkedIcon.png';
export const nonSelectedSession = './nonSelectedSession.png';
export const selectedSession = './selectedSession.png';
export const selectionIcon = './selectionIcon.png';
export const nextWhiteArrow = './nextWhiteArrow.png';
export const prevBlackArrow = './prevBlackArrow.png';
export const uncheckedCheckboxIcon = './unchecked-checkbox.png';
export const selected_checkBoxIcon = './selected_checkBox.png';
export const reportIcon = './reportIcon.png';
export const reportSelectedIcon = './reportSelectedIcon.png';
export const gridViewSelectedIcon = './newDarkThemeIcon/gridViewSelected.png';
export const gridViewIcon = './newDarkThemeIcon/gridView.png';
export const privateChatIcon = './newDarkThemeIcon/privateChat.png';
export const privateChatSelectedIcon =
  './newDarkThemeIcon/privateChatSelected.png';
export const groupChatIcon = './newDarkThemeIcon/groupChat.png';
export const groupChatSelectedIcon = './newDarkThemeIcon/GroupChatSelected.png';
export const enterFullScreenIcon = './newDarkThemeIcon/enterFullScreen.png';
export const exitFullScreenIcon = './newDarkThemeIcon/exitFullScreen.png';
export const toggleExpandIcon = './newDarkThemeIcon/toggleExpand.png';
export const toggleCollapsedIcon = './newImages/toggleCollapsed.png';
export const miniCollapsedIcon = './newImages/miniCollapsedIcon.png';

export const leaveMeetingIcon = './newImages/leaveMeetingIcon.png';
export const minimizeIcon = './newImages/minimizeIcon.png';
export const screenShareIcon = './newImages/screenShareIcon.png';
export const backgroundImage = './newImages/backgroundImage.png';
export const trashIcon = './trash.png';
export const noisyMicIcon = './newDarkThemeIcon/noisyMic.png';
export const noisySelectedMicIcon = './noisySelected.png';
export const disConnectedIcon = './disConnected.png';
export const videoDeniedPermissionIcon =
  './newDarkThemeIcon/videoDeniedPermission.png';
export const audioDeniedPermissionIcon =
  './newDarkThemeIcon/audioDeniedPermission.png';
export const signalStrengthBadIcon = './signalStrengthBad.png';
export const signalStrengthBestIcon = './signalStrengthBest.png';
export const signalStrengthgoodIcon = './signalStrengthgood.png';
export const myVideoIcon = '../newDarkThemeIcon/myVideoIcon.png';
export const myVideoSelectedIcon = './myVideoSelectedIcon.png';
export const showAllVideo = './showAllVideo.png';
export const arrowDownWhite = './newDarkThemeIcon/arrowDown.png';
export const studentListaudioDenied =
  './newDarkThemeIcon/studentListaudioDenied.png';
export const studentListMicroPhone =
  './newDarkThemeIcon/studentListmuteIcon.png';
export const studentListNoMicrophone =
  './newDarkThemeIcon/studentListUnmuteicon.png';
export const studentListNoVideo = './newDarkThemeIcon/studentListNoVideo.png';
export const idleMarkerIcon = './oldImages/idleMarker.png';
export const studentListVideo = './newDarkThemeIcon/studentListVideo.png';
export const studentListvideoDenied =
  './newDarkThemeIcon/studentListvideoDenied.png';

export const studentListHandRaised =
  './newDarkThemeIcon/studentListHandRaised.png';
export const studentListChat = './newDarkThemeIcon/studentListChat.png';
export const mesageSendTickIcon = './messageSendTick.png.png';
export const prevWhiteIcon = './newDarkThemeIcon/prevWhite.png';
export const enterFullScreen22Icon = './newDarkThemeIcon/enterFullScreen22.png';
export const helpIcon = './help.png';
export const otpLogo = './otp_logo_sec.png';
export const loginLogo = './loginImage.png';
export const classRoom_logo = './classroom_live_logo.png';
export const login_background = './login_background.png';
export const login_background_web = './login_background_web.png';
export const confirmationCrossIcon = './newDarkThemeIcon/confirmationCross.png';
export const arrowDownColored = './newDarkThemeIcon/arrowDownColored.png';
export const triangleDownWhiteDropdownIcon = './triangleDownWhiteDropdown.png';
export const triangleUpWhiteDropdown = './triangleUpWhiteDropdown.png';
export const tickWhiteIcon = './tickWhiteIcon.png';
export const ActiveStudentIcon = './ActiveStudentIcon.png';
export const ActiveStudentSelectedIcon = './ActiveStudentSelected.png';
export const pencilSelectedIcon = './canvasPenSelected.png';
export const pencilIcon = './canvasPen.png';
export const dropIcon = './Drop.png';
export const taxIcon = './tax_icon.png';

export const iraserIcon = './erageHilight.png';
export const iraserSelectedIcon = './erageHilightSlected.png';
export const moveCursor = './pointerHand.png';
export const moveCursorSelected = './pointerHandSelected.png';
export const zoom_in_preview = './zoom_in_preview.png';
export const zoom_out_preview = './zoom_out_preview.png';
export const reset_preview = './reset_preview.png';
export const link_icon = './linkIcon.png';
export const settingIcon = './settings@2x.png';
export const addIcon = './addicon.png';
export const uploadArrowIcon = './upload@3x.png';
export const smallUploadIcon = './smallUploadIcon.png';
export const rectangularChatIcon = './chatRectangleType.png';
export const eventIcon = './Event.png';
export const empty = './empty.png';
export const menu = './menu.png';
export const eventIconTop = './event_icon_top.png';
export const chatIconTop = './Chat_Icon_top.png';
export const Empty_Planner_Image = './Empty_Planner.png';
export const empty_3x = './empty@3x.png';
export const unitIcon = './unitIcon.png';
export const inputErrorIcon = './inputError.png';

// from headerImage for the header
export const workflowIcon = './headerImages/workflow.svg';
export const workflowSetUpIcon = './headerImages/setUp.svg';
export const workflowReviewIcon = './headerImages/review.svg';
export const workflowPlannerIcon = './headerImages/planner.svg';
export const workflowNotificationIcon = './headerImages/notification.svg';
export const workflowMyTaskIcon = './headerImages/myTask.svg';
export const workflowAddIcon = './headerImages/addIcon.svg';
export const workflowReportIcon = './headerImages/report.svg';
export const applyWorkflowIcon = './headerImages/workflowActive.svg';
export const applyWorkflowSetUpIcon = './headerImages/setUpActive.svg';
export const applyWorkflowReviewIcon = './headerImages/reviewActive.svg';
export const applyWorkflowPlannerIcon = './headerImages/plannerActive.svg';
export const applyWorkflowNotificationIcon =
  './headerImages/notificationActive.svg';
export const applyWorkflowMyTaskIcon = './headerImages/myTaskActive.svg';
export const applyWorkflowAddIcon = './headerImages/addIconActive.svg';
export const applyWorkflowreportIcon = './headerImages/reportActive.svg';
export const smallChatIcon = './headerImages/Chat1.png';
export const moderateChatIcon = './headerImages/Chat2.png';
export const bigChatIcon = './headerImages/Chat3.png';
export const rescheduleIcon = './Reschedule.png';
export const editWorkFlowIcon = './editWorkflow.png';
export const departmentIcon = './department.png';
export const topLevelFilterIconForDept = './top_level_filter_icon_for_dept.png';
export const whiteSettingsIcon = './headerImages/whiteSettingsIcon.png';
export const filterIcon = './ic_filter.png';
export const horizontalMoreOptionsIcon = './Options.png';
export const org2x = './Org@2x.png';
export const Unassign = './Unassigned.png';
export const downIconBlue = './blue_angleArrowDown.png';
export const blueArrowDown = './blue_arrow_down.png';
export const blueArrowBigDown = './blue_arrow_down@3x.png';
export const right = './right.png';
export const mediumRight = './right@2x.png';
export const bigRight = './right@3x.png';
export const icon_collapse = './Icon_Collaps.png';
export const icon_expand = './Icon_Expand.png';
export const icon_inProgress = './Icon_Inprogress.png';
export const icon_PDF = './Icon_PDF.png';
export const icon_completed = './Icon_Completed.png';

export const scheduleIcon = './scheduleIcon.png';
export const rightArrowIcon = './rightArrowIcon.png';
export const moveToInApprovalIcon = './moveToInApprovalIcon.png';
export const blueChatIcon = './blueChatIcon.png';
export const moreIcon = './moreIcon.png';
export const filters = './filters.png';
export const activeFilters = './activeFilters.png';
export const dateFilter = './dateFilter.png';
export const activeDateFilter = './activeDateFilter.png';
export const bluePencilIcon = './BluePencilIcon.png';
export const closeIcon = './Close.png';
export const locationActive = './locationActive.png';
export const loctionPermission = './loctionPermission.png';
export const BackgroundImage = './BackgroundImage.png';
export const MayaAiGirl = './MayaAiGirl.png';
export const HealthAssistant = './HealthAssistant.png';
export const appointments = './appointments.png';
export const preConsultMaya = './preConsultMaya.png';
export const preConsultMayaWhite = './preConsultMayaWhite.png';
export const selectSearchMaya = './selectSearchMaya.png';
export const AskQuestion = './AskQuestion.png';
export const mayaScheduleAppointment = './mayaScheduleAppointment.png';
export const getTreatment = './getTreatment.png';
export const medicalInformation = './medicalInformation.png';
export const doctorSearchMaya = './doctorSearchMaya.png';
export const location = './location.png';
export const doctorPatientChat = './doctorPatientChat.png';
export const hospitalLiveLogo = './loginlogo.png';
export const add_client_icon = './add_client.png';
export const edit_image = './edit_image.png';
export const approve_image = './approve.png';
export const add_image = './group-14.png';
export const add_icon = './group-14.png';
export const save_icon = './save.png';
export const setting_icon = './setting.png';
export const edit_icon = './edit.png';
export const back = './back.png';
export const editIcon = './editIcon.png';
export const temp_map = './temp_map.png';
export const delete_Image = './delete-vector.png';
export const modalCross = '/cross.png';
export const medicine = '/medicine.png';
export const roundCross = '/roundCross.png';
export const default_logo = './default_logo.png';
export const maleSign = './maleSign.png';
export const femaleSign = './femaleSign.png';
export const inviteLinksActive = './invitelinksActive.png';
export const inviteLinksInactive = './invitelinksInactive.png';
export const signalIcon = './signal_icon.png';
export const fullscreenIcon = './fullscreen-icon.png';
export const endCall = './endCall.png';
export const audioIcon = './audio.png';
export const muteIcon = './mute.png';
export const videoIcon = './video.png';
export const videoOffIcon = './videoOff.png';
export const snipToolIcon = './snip_tool.png';
export const myPatientsActive = './PatientsActive.png';
export const myPatientsInActive = './PatientsInActive.png';
export const downArrow_blue = './down_arrow.png';
export const sendMessageIcon = './sendMessage.png';
export const attachmentIcon = './attachment-icon.png';
export const pdfChatIcon = './pdfChat.png';
export const downloadChatIcon = './downloadChat.png';
export const whiteCrossIcon = './whiteCross.png';
export const VideoActive = './VideoActive.png';
export const VideoInactive = './VideoInactive.png';
export const Virtual = './doctorVist.png';
export const Doctor = './doctor.jpg';
export const Admin = './Admin.jpg';
export const FrontDesk = './frontDesk.jpg';
export const Patient = './Patient.jpg';
export const LessThan = './less-than.png';
export const MoreThan = './more-than.png';
export const checkbox_selected = './checkbox_selected.png';
export const calender = './calendar.png';
export const Watch = './watch.png';
export const Checkmark = './checkmark.png';
export const chatDownArrowIcon = './chatDownArrow.png';
export const doctorAppointment = '/doctorAppointment.png';
export const videoCall = '/videoCall.png';
export const pdf = '/pdf.png';
export const leftArrowPdf = '/left-arrow.png';
export const rightArrowPdf = '/right-arrow.png';
export const redCloseIcon = './closeRed.png';
export const activeStage = './active-stage.png';
export const backgroundImage1 = './backgroundImage.png';
export const HospitalLOGO = './group-19.png';
export const dropdown = './path.png';
export const searchFilter = './searchFilter.png';
export const greyTick = './grey-tick.png';
export const blueTick = './blue-tick.png';
export const greenTick = './green-tick.png';
export const ExperienceIcon = './experience.png';
export const AddressIcon = './address.png';
export const TrophyIcon = './trophy.png';
export const clockIcon = './clock.png';
export const calenderIconBlue = './calendarBlue.png';
export const Edit = './Edit.png';
export const myDoctorActive = './myDoctorActive.png';
export const myDoctor = './myDoctor.png';
export const descendingSortActiveIcon = './arrowDownSortActive.png';
export const ascendingSortActiveIcon = './arrowUpSortActive.png';
export const descendingSortUnActiveIcon = './arrowDownSort.png';
export const ascendingSortUnActiveIcon = './arrowUpSort.png';
export const TickForDelivery = './TickForDelivery.png';
export const StewardLogo = './StewardLogo.png';
export const HeaderNotification = './HeaderNotification.png';
export const patientRequests = './patientRequests.png';
export const patientRequestsActive = './patientRequestsActive.png';
export const MotivHealthLogo = './MotivHealthLogo.png';
export const dashboardIcon = './dashboard.png';
export const VaccineIcon = './VaccineIcon.png';
export const mapMarker = './mapMarker.png';
export const mapMarkerBlue = './mapMarkerBlue.png';
export const lessThanWhite = './lessThanWhite.png';
export const moreThanWhite = './moreThanWhite.png';
export const mayaMdLogoWhite = './mayaMdLogoWhite.png';
export const passwordHide = './passwordHide.png';
export const passwordShow = './passwordShow.png';
export const menuBar = './menu.png';
export const patientDoctorChat = './patientDoctorChat.png';
export const Lab = './Lab.jpeg';
export const downloadIconFile = './downloadIcon.png';
export const graphImage = './graphImage.png';
export const mayaMdLightLogo = './MayaMD4.png';
export const mayaMdDarkLogo = './MayaMD3.png';
export const DefaultAdds = './DefaultAdds.jpg';
export const nurse = './nurse.jpg';
export const AdForTemp = './AdForTemp.png';
export const dialysis = './dialysis.png';
export const nurseLogin = './nurseLogin.jpeg';
export const coppiedCareProgram = './coppiedCareProgram.png';
export const careProgramAdmin = './careProgramAdmin.png';
export const downArrowNew = './downArrowNew.png';
export const downArrowActiveNew = './downArrowActiveNew.png';
export const upArrowNew = './upArrowNew.png';
export const upArrowActiveNew = './upArrowActiveNew.png';
export const Bp = './Bp.png';
export const glucose = './glucose.png';
export const weighingMachine = './weighingMachine.png';
export const redBp = './redBp.png';
export const redGlucose = './redGlucose.png';
export const redWeighingMachine = './redWeighingMachine.png';
export const collapseNewIcon = './collapseNew.png';
export const expandNewIcon = './expandNew.png';
export const SVMLogo = './SVMLogo.png';
export const meghlayaGovtLogo1 = './meghlayaGovtLogo1.png';
export const editIconSecond = './EditIcon.png';
export const exportPdfIcon = './exportPdfIcon.png';
export const circlesImage ='./circles.svg'
export const labResultIcon ='./LabResultIcon.png'
export const registrationIcon ='./RegistrationIcon.png'
export const screeningIcon ='./ScreeningIcon.png'
